"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.catchUserErrors = catchUserErrors;
const display_1 = require("./display");
function catchUserErrors(fn, errorMsg) {
    return (...args) => {
        try {
            return fn(...args);
        }
        catch (err) {
            display_1.display.error(errorMsg, err);
        }
    };
}
//# sourceMappingURL=catchUserErrors.js.map